var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:{
      'chip': true,
      'label': _vm.label,
      'font-weight-bold': !_vm.noBold,
      'un-clickable': _vm.unClickable,
      rectangle: _vm.rectangle,
    },attrs:{"color":_vm.color,"text-color":_vm.textColor,"x-small":_vm.xs,"small":_vm.small,"outlined":_vm.outlined,"link":_vm.link,"close":_vm.close,"ripple":!_vm.unClickable,"close-icon":_vm.closeIcon},on:{"click":function($event){return _vm.$emit('click')},"click:close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }